import { createRootRoute, Outlet } from "@tanstack/react-router";
import { AuthProvider } from "@/components/providers/AuthProvider";
import { PublicKeysProvider } from "@/components/providers/PublicKeysProvider";
import { HeaderContextProvider } from "@/components/layout/HeaderContext";
import { LoginModalProvider } from "@/components/auth/LoginModalProvider";
import { OnboardingProvider } from "@/components/onboarding/OnboardingProvider";
import { ProfileSidePanelProvider } from "@/components/profile/ProfileSidePanelProvider";

export const Route = createRootRoute({
  component: RootLayout,
});

function RootLayout() {
  return (
    <PublicKeysProvider>
      <AuthProvider>
        <LoginModalProvider>
          <OnboardingProvider>
            <ProfileSidePanelProvider>
              <HeaderContextProvider>
                <div className="min-h-screen bg-background text-text-primary">
                  {/* Main content area */}
                  <main className="flex flex-col min-h-screen">
                    <Outlet />
                  </main>
                </div>
              </HeaderContextProvider>
            </ProfileSidePanelProvider>
          </OnboardingProvider>
        </LoginModalProvider>
      </AuthProvider>
    </PublicKeysProvider>
  );
}
